import {API} from "aws-amplify";
import MaterialTable from "material-table";
import GroupIcon from '@material-ui/icons/Group';
import React, {forwardRef, useEffect, useState} from 'react';
import ModalChooseGroup from "../../Modals/ModalChooseGroup";
import ModalExtraordinarioFecha from "../../Modals/ModalExtraordinarioFecha";
import RemoveCircleOutlineIcon from '@material-ui/icons/RemoveCircleOutline';
import {LOCALIZATION} from "../../Material-TableCustomization/Localization/LocalizationES";
import {REMOVE_DROP_SHADOW} from "../../Material-TableCustomization/CSSChanges/RemoveDropShadow";
import {ICONS_OVERRIDE_SECONDARY_COLOR} from "../../Material-TableCustomization/IconsOverride/IconsOverrideSecondaryColor";
import {STUDENTS_GRADES_TABLE_COLUMN_DEFINITION} from "../../Material-TableCustomization/ColumnsDefinition/StudentGradesTableColumnDefinition";
import {red} from "@material-ui/core/colors";
import {
    ENFERMERIA_STUDENTS_GRADES_TABLE_COLUMN_DEFINITION
} from "../../Material-TableCustomization/ColumnsDefinition/EnfermeriaStudentGradesTableColumnDefinition";

export default function StudentGradesTable(props) {
    const [grades, setGrades] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [selectedRow, setSelectedRow] = useState([]);
    const [openChooseGroupModal, setOpenChooseGroupModal] = useState(false);
    const [openExtraFechaModal, setOpenExtraFechaModal] = useState(false);
    const [pendingGradeUpdate, setPendingGradeUpdate] = useState(null);
    const tableIcons = {
        RemoveIcon: forwardRef((props, ref) => <RemoveCircleOutlineIcon color="secondary" {...props} ref={ref}/>),
        GroupIcon: forwardRef((props, ref) => <GroupIcon color="secondary" {...props} ref={ref}/>)
    };

    useEffect(() => {
        loadGrades();
    }, []);

    const updateEnfermeriaStudentGradeApi = newGrade => {
        const url = `/enfermeria/${newGrade?.topicId}/grades/${props.student?.studentUuid}`;
        return API.put("misServiciosEscolares", url, {
            body: newGrade
        });
    };

    function loadStudentGradesApi() {
        return API.get("misServiciosEscolares", `/grades/${props.student?.studentUuid}?fullDetails=true`);
    }

    const loadGrades = async () => {
        setIsLoading(true);
        try {
            const response = await loadStudentGradesApi();
            setGrades(response.grades ?? response);
        } catch (e) {
            console.log(e);
        } finally {
            setIsLoading(false);
        }
    };

    const updateStudentGradeApi = (updatedStudentGrade, action) => {
        const payload = {
            studentUuid: props.student.studentUuid,
            topicId: updatedStudentGrade.topicId,
            grades: updatedStudentGrade
        };
        const actionParam = action ? action : "ADD";
        return API.put("misServiciosEscolares", `/grades?type=single&action=${actionParam}`, {
            body: payload
        });
    }

    const hasValue = value => value !== undefined && value !== null && `${value}`.trim() !== "";

    // TODO: Refactor all the onRowUpdate to this format
    const handleOnRowUpdate = async (updatedStudent, oldStudent, resolve, reject) => {
        const extraChanged = hasValue(updatedStudent.extraordinario)
            && (updatedStudent.extraordinario !== oldStudent?.extraordinario || !hasValue(updatedStudent.extraordinarioFecha));
        if (extraChanged) {
            // Before saving, ask for the date the extraordinario exam took place
            setPendingGradeUpdate({updatedStudent, resolve, reject});
            setOpenExtraFechaModal(true);
            return;
        }
        await saveRowUpdate(updatedStudent, resolve, reject);
    };

    const handleExtraFechaConfirm = async (fecha) => {
        setOpenExtraFechaModal(false);
        const {updatedStudent, resolve, reject} = pendingGradeUpdate;
        setPendingGradeUpdate(null);
        await saveRowUpdate({...updatedStudent, extraordinarioFecha: fecha}, resolve, reject);
    };

    const handleExtraFechaSkip = async () => {
        setOpenExtraFechaModal(false);
        const {updatedStudent, resolve, reject} = pendingGradeUpdate;
        setPendingGradeUpdate(null);
        await saveRowUpdate(updatedStudent, resolve, reject);
    };

    const handleDeleteExtraFecha = async (rowData) => {
        if (!window.confirm("¿Borrar la fecha del extraordinario de esta materia?")) return;
        setIsLoading(true);
        try {
            if (props.student?.major.toUpperCase().includes("ENFERMERIA")) {
                // Empty string tells the backend to remove the field
                await updateEnfermeriaStudentGradeApi({...rowData, extraordinarioFecha: ""});
            } else {
                // The SINGLE update replaces the whole topic map, so omitting the field deletes it
                const {extraordinarioFecha, ...gradeWithoutFecha} = rowData;
                await updateStudentGradeApi(gradeWithoutFecha);
            }
            await loadGrades();
        } catch (e) {
            alert('Por favor intente de nuevo');
        } finally {
            setIsLoading(false);
        }
    };

    const saveRowUpdate = async (updatedStudent, resolve, reject) => {
        try {
            if (props.student?.major.toUpperCase().includes("ENFERMERIA")) {
                await updateEnfermeriaStudentGradeApi(updatedStudent);
            } else {
                await updateStudentGradeApi(updatedStudent);
            }
            await loadGrades();
            // let index = grades.findIndex(o => o.topicId === responseUpdate.topicId);
            // setGrades([
            //     ...grades.slice(0, index),
            //     responseUpdate,
            //     ...grades.slice(index + 1)
            // ]);
        } catch (e) {
            alert('Por favor intente de nuevo');
            reject();
        } finally {
            resolve();
        }
    };

    function handleOnRowAdd(newItem) {
        let index = grades.findIndex(o => o.topicId === newItem.topicId);
        setGrades([
            ...grades.slice(0, index),
            {...grades[index], externalGroupId: newItem.externalGroupId},
            ...grades.slice(index + 1)
        ]);
    }


    return (
        <div>
            <ModalExtraordinarioFecha
                open={openExtraFechaModal}
                initialFecha={pendingGradeUpdate?.updatedStudent?.extraordinarioFecha}
                onConfirm={handleExtraFechaConfirm}
                onSkip={handleExtraFechaSkip}
            />
            <ModalChooseGroup
                openChooseGroupModal={openChooseGroupModal}
                callbackClose={setOpenChooseGroupModal}
                setIsLoading={setIsLoading}
                selectedTopic={selectedRow} student={props.student} callbackResponse={handleOnRowAdd}
            />
            <MaterialTable
                columns={
                    props.student?.major.toUpperCase().includes("ENFERMERIA")
                        ? ENFERMERIA_STUDENTS_GRADES_TABLE_COLUMN_DEFINITION({...props, onDeleteExtraFecha: handleDeleteExtraFecha})
                        : STUDENTS_GRADES_TABLE_COLUMN_DEFINITION({...props, onDeleteExtraFecha: handleDeleteExtraFecha})
                }
                data={grades}
                title="Calificaciones"
                isLoading={isLoading}
                components={REMOVE_DROP_SHADOW}
                icons={ICONS_OVERRIDE_SECONDARY_COLOR}
                localization={LOCALIZATION('materia', 'materias')}
                options={{
                    paging: false,
                    rowStyle: rowData => {
                        return {backgroundColor: rowData.failed ? red[100] : '#FFF'};
                    }
                }}
                // TODO: Change all the updates to this format
                editable={{
                    onRowUpdate: (newData, oldData) => new Promise((resolve, reject) => {
                        handleOnRowUpdate(newData, oldData, resolve, reject);
                    }),
                }}
                actions={[
                    {
                        icon: tableIcons.GroupIcon,
                        onClick: (event, rowData) => {
                            console.log(rowData);
                            setSelectedRow(rowData);
                            setOpenChooseGroupModal(true);
                        }
                    },
                ]}
            />
        </div>
    );
};